import { type JSX } from 'react';
import Drawer from '@mui/material/Drawer';
import { type ModalProps } from './modal';
import { modalClasses } from './modal.classes';
import { useModalStyles } from './modal.styles';

export const ModalSmallViewport = ({
  isOpen,
  className,
  styles,
  children,
  role,
  onClose,
  ...rest
}: ModalProps): JSX.Element => {
  const css = useModalStyles();

  return (
    <Drawer
      {...rest}
      onClose={onClose}
      role={role ?? 'dialog'}
      aria-modal='true'
      anchor='bottom'
      open={isOpen}
      classes={{ paperAnchorBottom: modalClasses.container }}
      className={className}
      transitionDuration={{ enter: 200, exit: 100 }}
      ModalProps={{
        slotProps: {
          backdrop: {
            classes: { root: modalClasses.backdrop },
            style: styles?.backdrop,
            sx: css.backdrop,
          },
        },
      }}
      PaperProps={{
        sx: {
          color: 'inherit',
        },
      }}
      style={styles?.root}
      css={css.root}
    >
      {children}
    </Drawer>
  );
};
